import useMicrofrontend from "../hooks/useMicrofrontend";

export const LoginBox = () => {
    useMicrofrontend("login-box", "/services/login/login-bundle.js");

    return (
        <div>
            <div id={"login-box"} data-button-link-url={"../../services/payments/#debtPage"}></div>
        </div>
    );
};
